import { render, staticRenderFns } from "./ExportStudentPayments.vue?vue&type=template&id=6603bf4c"
import script from "./ExportStudentPayments.vue?vue&type=script&lang=ts"
export * from "./ExportStudentPayments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports